/* Lumika: nõusolekupõhised huvisündmused. Ei lisa PageView/Lead/Purchase sündmusi. */
(function () {
  'use strict';
  if (window.__lumikaMetaEvents) return;
  window.__lumikaMetaEvents = true;
  var pixel = '529714586811872', started = false, lastResult = '', timer;
  function allowed() {
    var c = window.Shopify && window.Shopify.customerPrivacy;
    return !!(c && typeof c.marketingAllowed === 'function' && c.marketingAllowed() &&
      typeof c.analyticsProcessingAllowed === 'function' && c.analyticsProcessingAllowed());
  }
  function send(name, data) {
    if (!allowed() || typeof window.fbq !== 'function') return false;
    var state = window.fbq.getState && window.fbq.getState();
    if (!state || !state.pixels || !state.pixels.some(function (p) { return p.id === pixel; })) return false;
    // Ainult mudel, võimsusvahemik ja lehe liik; vormivälju ega kontaktandmeid ei loeta.
    window.fbq('trackSingleCustom', pixel, name, data || {});
    return true;
  }
  function loadConsent() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  }
  loadConsent();
  document.addEventListener('visitorConsentCollected', function () {
    // Enne nõusolekut toimunud tegevusi tagantjärele ei saadeta.
    if (!allowed()) { started = false; lastResult = ''; }
    loadConsent();
  });
  function category() {
    var path = location.pathname;
    return path === '/pages/diiselgeneraatorid' ? 'generator_selector' :
      path.indexOf('/products/') === 0 ? 'product' :
      path.indexOf('rent') !== -1 ? 'rental' : 'other';
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-gc-quote-model]');
    if (target) {
      var model = (target.getAttribute('data-gc-quote-model') || '').slice(0,120);
      // Kinnita, et nupp avas päriselt pakkumisdialoogi.
      setTimeout(function () {
        var dialog = document.getElementById('lumika-generator-quote');
        if (dialog && dialog.open) send('RequestQuoteClick', { content_name: model, page_category: category() });
      }, 0);
      return;
    }
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (/^(tel:|mailto:)/i.test(href)) send('ContactClick', {
      contact_method: /^tel:/i.test(href) ? 'phone' : 'email', page_category: category()
    });
  });
  function calculator() {
    if (location.pathname !== '/pages/diiselgeneraatorid') return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var input = document.getElementById('gc-value'), unit = document.getElementById('gc-unit');
      if (!input || !unit || !unit.value || !allowed()) return;
      var value = Number(input.value); if (!(value > 0)) return;
      var kw = unit.value === 'kw' ? value : unit.value === 'kva' ? value * .8 : unit.value === 'a' ? value * 400 * Math.sqrt(3) * .8 / 1000 : 0;
      if (!kw) return;
      var band = kw <= 20 ? '0-20kW' : kw <= 50 ? '20-50kW' : kw <= 100 ? '50-100kW' : kw <= 200 ? '100-200kW' : '200+kW';
      if (!started) started = send('GeneratorToolStart', { page_category: 'generator_selector' });
      var count = document.querySelectorAll('[data-gc-quote-model]').length;
      var key = unit.value + ':' + value + ':' + count;
      if (count && key !== lastResult && send('GeneratorResults', { power_band: band, result_count: count })) lastResult = key;
    }, 700);
  }
  ['input','change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (/^gc-(value|unit|stage-v|stock-only)$/.test(event.target.id || '')) calculator();
    });
  });
})();
